import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const NotificationsPage = lazy(() => import('~/features/notifications/pages/notifications-page'));

export const Route = createFileRoute('/_authenticated/_tenant/settings_/notification')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <NotificationsPage />
    </Suspense>
  ),
});
